import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@icon/resize.svg'


const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "value", "placeholder", "readonly", "maxlength"]
const _hoisted_3 = {
  key: 2,
  class: "bordered-textarea__buttons"
}
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClueTooltip = _resolveComponent("ClueTooltip")!
  const _component_icon = _resolveComponent("icon")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createBlock(_component_Field, {
    as: _ctx.validationTag,
    modelValue: _ctx.content,
    name: _ctx.id,
    rules: _ctx.rules,
    validateOnBlur: _ctx.validateOnBlur,
    validateOnModelUpdate: _ctx.validateOnModelUpdate,
    validateOnInput: _ctx.validateOnInput,
    validateOnChange: false,
    class: _normalizeClass(["bordered-textarea", {
      'bordered-textarea_without-resize': !_ctx.resize
    }])
  }, {
    default: _withCtx(({ errors }) => [
      (_ctx.label.length)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            for: _ctx.id,
            class: "body-text body-text-medium-400"
          }, [
            _renderSlot(_ctx.$slots, "label", {}, () => [
              _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
              (_ctx.tooltip)
                ? (_openBlock(), _createBlock(_component_ClueTooltip, {
                    key: 0,
                    text: _ctx.tooltipText
                  }, null, 8, ["text"]))
                : _createCommentVNode("", true)
            ])
          ], 8, _hoisted_1))
        : _createCommentVNode("", true),
      _createElementVNode("textarea", {
        id: _ctx.id,
        value: _ctx.modelValue,
        rows: "1",
        placeholder: _ctx.placeholder,
        class: _normalizeClass(["custom-scroll", { 'is-error': errors[0] || _ctx.customErrorMessage }]),
        readonly: _ctx.readonly,
        maxlength: _ctx.maxlength,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleInput($event.target.value))),
        onMousedown: _cache[1] || (_cache[1] = ($event: any) => ($event.stopPropagation())),
        onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('onBlur')))
      }, null, 42, _hoisted_2),
      (_ctx.resize)
        ? (_openBlock(), _createBlock(_component_icon, {
            key: 1,
            data: _imports_0,
            width: "9",
            height: "9",
            color: "#7D92A7",
            class: "bordered-textarea__icon"
          }))
        : _createCommentVNode("", true),
      (_ctx.addButtons)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              class: "secondary-button secondary-button_small btn",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
            }, " Cancel "),
            _createElementVNode("button", {
              type: "button",
              disabled: !_ctx.content.length,
              class: "primary-button primary-button_small btn",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSave && _ctx.onSave(...args)))
            }, " Save ", 8, _hoisted_4)
          ]))
        : _createCommentVNode("", true),
      (errors[0] || _ctx.customErrorMessage)
        ? (_openBlock(), _createElementBlock("span", {
            key: 3,
            class: _normalizeClass(["error-text bordered-input__error", { 'error-text-small': _ctx.isSmallErrorText }])
          }, _toDisplayString(errors[0] ?? _ctx.customErrorMessage), 3))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["as", "modelValue", "name", "rules", "validateOnBlur", "validateOnModelUpdate", "validateOnInput", "class"]))
}